export default function About() {
  return (
    <main className="content-page">
      <div className="eyebrow">History, mapped</div>
      <h1 className="headline">About everwhz</h1>
      <p className="subline">
        A podcast player for exploring history across time and place.
      </p>
      <article className="episode">
        <h2 className="ep-title">Take the archive with you</h2>
        <p className="ep-description">
          Browse and listen to your favorite history podcasts on the web or on
          your phone.
        </p>
        <a
          className="top-btn"
          href="https://apps.apple.com/us/app/everwhz/id6504833826"
          target="_blank"
          rel="noopener noreferrer"
        >
          Download on the App Store ↗
        </a>
      </article>
      <p className="subline">
        Feedback appreciated:{" "}
        <a className="ep-link" href="mailto:anthonylouisburns@gmail.com">
          anthonylouisburns@gmail.com
        </a>
      </p>
    </main>
  );
}
